module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Scissors-5b72a3958f796c5f77c6b851b19dd9c3.svg";